import UserTypes from "./user.types";
import {configToken, userIsDemoOrNot} from "./user.utils";

export const SetUser = data =>({
    type: UserTypes.SET_USER,
    payload: data
});
export const SetIsDemo = data =>({
    type: UserTypes.SET_IS_DEMO,
    payload: userIsDemoOrNot(data)
});
export const SetToken = token =>({
    type: UserTypes.GET_TOKEN,
    payload: token
});
export const SetIosAndroid = deviceType =>({
    type: UserTypes.SET_IOS_ANDROID,
    payload: deviceType
});
